import { render, staticRenderFns } from "./dataloading.vue?vue&type=template&id=1e3971d7&scoped=true&"
import script from "./dataloading.vue?vue&type=script&lang=js&"
export * from "./dataloading.vue?vue&type=script&lang=js&"
import style0 from "./dataloading.vue?vue&type=style&index=0&id=1e3971d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3971d7",
  null
  
)

/* custom blocks */
import block0 from "./dataloading.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VProgressLinear})
